import { enqueueSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

const useFormRules = () => {
	const { t } = useTranslation();

	const formRules = {
		requiredField: {
			required: t('form.rules.field.required'),
		},
		username: {
			required: t('form.rules.field.required'),
			validate: {
				noSpace: (value: string) =>
					(value && !/\s+/.test(value)) || t('form.rules.no.space'),
				length: (value: string) =>
					(value && value.length < 50) ||
					t('form.rules.username.length'),
			},
		},
		nickname: {
			required: t('form.rules.field.required'),
			validate: {
				noSpace: (value: string) =>
					(value && !/\s+/.test(value)) || t('form.rules.no.space'),
				length: (value: string) =>
					(value && value.length < 50) ||
					t('form.rules.nickname.length'),
			},
		},
		email: {
			required: t('form.rules.email.required'),
			pattern: {
				value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
				message: t('form.rules.email.invalid'),
			},
		},
		Pwd: {
			required: t('form.rules.pwd.required'),
			validate: {
				noSpace: (value: string) =>
					(value && !/\s+/.test(value)) || t('form.rules.no.space'),
				length: (value: string) =>
					(value && value.length >= 6) || t('form.rules.pwd.length'),
			},
		},
		newPwd: {
			required: t('form.rules.pwd.required'),
			validate: {
				noSpace: (value: string) =>
					(value && !/\s+/.test(value)) || t('form.rules.no.space'),
				length: (value: string) =>
					(value && value.length >= 6) || t('form.rules.pwd.length'),
			},
		},
		captcha: {
			required: t('form.rules.captcha.required'),
			validate: {
				noSpace: (value: string) =>
					(value && !/\s+/.test(value)) || t('form.rules.no.space'),
			},
		},
		checkbox: {
			validate: (val: boolean) => {
				if (!val) {
					enqueueSnackbar(t('form.rules.checkbox.required'), {
						variant: 'error',
					});
					return false;
				}
			},
		},
		phone: {
			required: t('form.rules.field.required'),
			validate: {
				numberOnly: (value: string) =>
					(value && /^\d+$/.test(value)) ||
					t('form.rules.number.only'),
				length: (value: string) =>
					(value && value.length <= 20) ||
					t('form.rules.phone.length'),
			},
		},
		authnCode: {
			required: t('form.rules.field.required'),
			validate: {
				length: (value: string) =>
					(value && value.length == 6) || t('product.dialog.err'),
			},
		},
	};

	return {
		formRules,
	};
};

export default useFormRules;
